export default __webpack_public_path__ + "static/media/thum5.15be457f.jpg";